import React, { Component } from 'react';
import Input from '../../components/UI/Input/Input';

import Spinner from '../../components/UI/Spinner/Spinner';
import classes from '../../index.css';
import * as messages from '../../messages';
import axios from '../../axios-ns';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Aux from '../../hoc/Aux';
import TextField from '@material-ui/core/TextField';

class BuyProduct extends Component {
    state = {
        originalPrice: 0,
        product: null,
        error: null,
        loading: true,
        controls: null,
        color: 'red'
    };

    newUserControls = {
        firstName: {
            elementType: 'input',
            elementConfig: {
                type: 'input',
                placeholder: 'Twoje imię'
            },
            value: '',
            validation: {
                required: true,
                isEmail: false
            },
            touched: false,
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'input',
                placeholder: 'Twój adres email'
            },
            value: '',
            validation: {
                required: true,
                isEmail: true
            },
            touched: false
        },
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'password',
                placeholder: 'Twoje hasło'
            },
            value: '',
            validation: {
                required: true,
                minLength: 6
            },
            touched: false
        },
        repeatPassword: {
            elementType: 'input',
            elementConfig: {
                type: 'password',
                placeholder: 'Powtórz hasło'
            },
            value: '',
            validation: {
                required: true,
                minLength: 6,
                sameAs: 'password'
            },
            touched: false
        },
        paymentMethod: {
            elementType: 'select',
            elementConfig: {
                options: [
                    { value: 'ONLINE_TRANSFER', displayValue: messages['ONLINE_TRANSFER'] },
                    { value: 'BANK_TRANSFER', displayValue: messages['BANK_TRANSFER'] },
                    { value: 'PAYPAL', displayValue: messages['PAYPAL'] }
                ]
            },
            value: 'ONLINE_TRANSFER',
            validation: {
                required: true
            }
        }
    };

    existingUserControls = {
        paymentMethod: {
            elementType: 'select',
            elementConfig: {
                options: [
                    { value: 'ONLINE_TRANSFER', displayValue: messages['ONLINE_TRANSFER'] },
                    { value: 'BANK_TRANSFER', displayValue: messages['BANK_TRANSFER'] },
                    { value: 'PAYPAL', displayValue: messages['PAYPAL'] }
                ]
            },
            value: 'ONLINE_TRANSFER',
            validation: {
                required: true
            }
        }
    };

    componentWillMount() {
        if (localStorage.getItem('token')) {
            this.setState({ ...this.state, controls: this.existingUserControls });
        } else {
            this.setState({ ...this.state, controls: this.newUserControls });
        }
    }

    componentDidMount() {
        axios.get('product/' + this.props.match.params.code)
            .then(response => {
                this.setState({ originalPrice: response.data.price, product: response.data, loading: false });
            }).catch(err => {
                this.setState({ loading: false, message: null, error: messages[err.response.data.message] });
            });

        if (!localStorage.getItem('token')) {

            axios.get('/agreements')
                .then(response => {
                    response.data.forEach(a => {
                        let required = a.required == '1' ? true : false;

                        this.setState({
                            ...this.state, controls: {
                                ...this.state.controls,
                                [a.agreementCode]: {
                                    elementType: 'input',
                                    labelStyle: { fontSize: '10px', textAlign: 'justify', marginTop: '-10px' },
                                    elementConfig: {
                                        type: 'checkbox',
                                        label: (required ? '*' : '') + a.content
                                    },
                                    value: a.agreementCode,
                                    validation: {
                                        required: required,
                                    },
                                    touched: false
                                }
                            }, loading: false
                        });
                    })
                })
                .catch(err => {

                });
        }
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                checked: event.target.checked,
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    discountCodeChangeHandler = (event) => {
        this.setState({ ...this.state, discountCode: event.target.value }, () => {
            if (this.state.discountCode.length >= 5) {
                axios.get('discountCode/' + this.state.discountCode)
                    .then(response => {
                        this.setState({ ...this.state, product: { ...this.state.product, price: (this.state.product.price - response.data.value) } });
                    }).catch(err => {
                        this.setState({ ...this.state, product: { ...this.state.product, price: this.state.originalPrice } });
                    });
            } else {
                this.setState({ ...this.state, product: { ...this.state.product, price: this.state.originalPrice } });
            }
        });
    }

    isValid(controls) {
        let updatedControls = {
            ...this.state.controls,
        };

        let valid = true;

        for (let key in updatedControls) {
            const validation = updatedControls[key].validation;
            const value = updatedControls[key].elementConfig.type === 'checkbox' ? updatedControls[key].checked : updatedControls[key].value;

            if (validation.required && (!value || value === '')) {
                updatedControls[key].error = messages['ERR_REQUIRED'];
                valid = false;
            } else if (validation.minLength && validation.minLength > value.length) {
                updatedControls[key].error = messages['ERR_MINLENGTH'].replace('%', validation.minLength);
                valid = false;
            } else if (validation.isEmail && !this.isEmail(value)) {
                updatedControls[key].error = messages['ERR_ISEMAIL'];
                valid = false;
            } else if (validation.sameAs && value !== updatedControls[validation.sameAs].value) {
                updatedControls[key].error = messages['ERR_SAMEAS'].replace('%', messages[validation.sameAs.toUpperCase()]);
                valid = false;
            } else {
                updatedControls[key] = { ...updatedControls[key], error: null };
            }

        };

        this.setState({ controls: updatedControls });

        return valid;
    }

    isEmail(email) {
        //let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    submitHandler = (event) => {
        this.setState({ ...this.state, loading: true });
        event.preventDefault();

        if (!this.isValid(this.state)) {
            this.setState({ ...this.state, loading: false });
            return;
        }

        let user;

        if (localStorage.getItem('token')) {
            user = { hasToken: true }
        } else {
            user = {
                firstName: this.state.controls.firstName.value,
                email: this.state.controls.email.value,
                password: this.state.controls.password.value,
                agreements: []
            }
        }

        let buyObj = {
            user: user,
            paymentMethod: this.state.controls.paymentMethod.value,
            discountCode: this.state.discountCode,
            agreements: [],
            productCode: this.state.product.code
        };

        Object.keys(this.state.controls).filter(k => k.indexOf('rodo') >= 0 && this.state.controls[k].checked).forEach(k => {
            buyObj['user']['agreements'].push(this.state.controls[k].value);
        });


        this.buyWithSignUp(buyObj);
    }

    buyWithSignUp = (buyWithSignUpData) => {
        let prot = localStorage.getItem('token') ? 'protected/' : '';
        let url = prot + 'transaction';

        let config = localStorage.getItem('token') ? { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } } : null;

        axios.post(url, buyWithSignUpData, config)
            .then(response => {
                this.setState({ ...this.state, loading: false, error: null });
                this.props.history.replace('/payment-method/' + response.data.code + '/' + response.data.paymentMethod);
            })
            .catch(err => {
                this.setState({ ...this.state, loading: false, error: err.response.data });
            });
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    error={formElement.config.error}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let view = null;

        if (this.state.loading) {
            view = <Spinner />
        } else {

            let errorMessage = null;

            if (this.state.error) {
                errorMessage = (
                    <p style={{ color: '#f50057' }}>{messages[this.state.error.message]}</p>
                )
            }

            let productInfo = this.state.product ? <p>{this.state.product.name} - {this.state.product.price} zł</p> : <Spinner />;

            view = (

                <Card className={classes.Form}>
                    <CardHeader title={messages.COURSE_PAYFORM} className={classes.Head} />
                    {productInfo}
                    {errorMessage}
                    <form onSubmit={this.submitHandler}>
                        {form}

                        <div style={{width: '500px'}}>
                            <TextField
                                id="outlined-multiline-flexible"
                                label="Kod rabatowy"
                                key="discountCode"
                                rowsMax="1"
                                style={{ width: '300px', marginLeft: '10px', marginRight: '30px', marginBottom: '20px', fontColor: this.state.color }}
                                value={this.state.discountCode}
                                onChange={(event) => this.discountCodeChangeHandler(event)}
                                margin="normal"
                                helperText="Wprowadź kod rabatowy"
                            />
                        </div>

                        <Button color="primary" variant="outlined" type="submit" style={{ marginBottom: '20px' }}>
                            {messages.BUY_NOW}
                        </Button>
                    </form>
                </Card>);
        }

        return (
            <Aux>
                {view}
            </Aux>
        )
    }
}

export default BuyProduct; 